module.exports = __webpack_public_path__ + "static/read-43e968872cad5fa83e9fd1156124c94e.png";